import React, { Component } from 'react'
// import './index.module.less'
/**
 * 用户中心组件
 */
class HeaderTopNav extends Component {
    static defaultProps = {
      channelList: [],
      stickChannelList: [],
      isIndex: true,
      isMoreNavShow: false
    }
    constructor (props) {
      super(props)
      this.state = {
        date: new Date(),
        isIndex: props.isIndex
      }

      this.hideMoreNavTimer = null

      this.showMoreNav = this.showMoreNav.bind(this)
    }

    showMoreNav () {
      if (this.hideMoreNavTimer) {
        window.clearTimeout(this.hideMoreNavTimer)
      }
      if (this.state.isMoreNavShow) {
        return
      }
      this.setState({
        isMoreNavShow: true
      })
    }

    hideMoreNav () {
      if (this.hideMoreNavTimer) {
        window.clearTimeout(this.hideMoreNavTimer)
      }
      this.hideMoreNavTimer = window.setTimeout(() => {
        if (!this.state.isMoreNavShow) {
          return
        }
        this.setState({ isMoreNavShow: false })
      }, 300)
    }

    renderBlock (start, end) {
      end = end > this.props.channelList.length ? this.props.channelList.length : end
      let _subList = this.props.channelList.slice(start, end)
      return (
        <dd>{
          _subList.map((item, i) => {
            return <a key={i} href={item.domain}>{item.name}</a>
          })
        }
        </dd>
      )
    }

    renderLeftNav () {
      if (this.props.isIndex) {
        return (
          <ul className={'g-head-nav isindex'}>
            {
              this.props.stickChannelList.map((item, i) => {
                const className = i > 1 ? 's-hide1' : 's-hide'
                return <li key={i} className={className}><a href={item.domain}>{item.name}</a> </li>
              })
            }
            <li className='g-view top-nav-more-large' onMouseOver={this.showMoreNav.bind(this)} onMouseOut={this.hideMoreNav.bind(this)}> <a href='javascript:void(0);' > <span className='ico-list' />频道</a>
              {this.renderHideList()}
            </li>
          </ul>)
      } else {
        return (
          <ul className='g-head-nav'>
            <li className='g-view top-nav-more-large s-hide'><a href='//www.youku.com'> <span className='ico-home' />首页</a></li>
            <li className='g-view top-nav-more-large' onMouseOver={this.showMoreNav.bind(this)} onMouseOut={this.hideMoreNav.bind(this)}> <a href='javascript:void(0);' > <span className='ico-list' />频道</a>
              {this.renderHideList()}
            </li>
          </ul>)
      }
    }

    renderHideList () {
      return <ul style={{ display: `${this.state.isMoreNavShow ? 'block' : 'none'}` }}>
        <li className='arrow' />
        <li>
          <div className='content'>
            <dl className='top-nav-channel'>
              {this.renderBlock(0, 6)}
              {this.renderBlock(6, 12)}
              {this.renderBlock(12, 18)}
              {this.renderBlock(18, 24)}
              {this.renderBlock(24, 26)}
            </dl>
          </div>
        </li>
      </ul>
    }
    render () {
      return (
        <div className='g-head-center'>
          {this.renderLeftNav()}
        </div>
      )
    }
}
export default HeaderTopNav
